import { Component } from '@angular/core';
import { Subject } from 'rxjs';
import { GlobalSpinnerService } from './global-spinner.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AsyncPipe, CommonModule } from '@angular/common';

@Component({
  selector: 'app-global-spinner',
  templateUrl: './global-spinner.component.html',
  styleUrls: ['./global-spinner.component.css'],
  imports: [CommonModule, MatProgressSpinnerModule, AsyncPipe]
})
export class GlobalSpinnerComponent {

  isLoading: Subject<boolean> = this.globalSpinnerService.isLoading;

  constructor(private globalSpinnerService: GlobalSpinnerService) {
  }

}
